module.exports = __webpack_public_path__ + "img/spartan-masonry-concrete-tile-05-large.6e702891.jpg";